import {ConditionOperatorKey} from '../conditions/conditions.types';
import {CompoundCondition, CompoundConditionRule} from './compoundConditions.types';

export const DEFAULT_RULE: CompoundConditionRule = {
  signal: {name: '', value: '', categories: []},
  ruleOperator: ConditionOperatorKey.Equal,
  ruleValue: {},
};

export const DEFAULT_CONDITION: CompoundCondition = {sections: [{rules: [DEFAULT_RULE]}]};
